import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaModalComponent implements OnInit {
  title: string;
  description: string;
  mediaUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; description: string; mediaUrl: string },
    public dialogRef: MatDialogRef<MediaModalComponent>
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.description = this.data.description;
    this.mediaUrl = this.data.mediaUrl;
  }

  close(): void {
    this.dialogRef.close({});
  }

  isImage(src: string): boolean {
    const isImage = src.includes('jpg') || src.includes('png');

    return isImage;
  }
}
